var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9419 3.93306C13.186 4.17714 13.186 4.57286 12.9419 4.81694L4.81694 12.9419C4.69973 13.0592 4.54076 13.125 4.375 13.125L1.875 13.125C1.70924 13.125 1.55027 13.0592 1.43306 12.9419C1.31585 12.8247 1.25 12.6658 1.25 12.5L1.25 10C1.25 9.83424 1.31585 9.67527 1.43306 9.55806L9.55806 1.43306C9.80214 1.18898 10.1979 1.18898 10.4419 1.43306C10.686 1.67714 10.686 2.07286 10.4419 2.31694L2.5 10.2589L2.5 11.875L4.11612 11.875L12.0581 3.93306C12.3021 3.68898 12.6979 3.68898 12.9419 3.93306Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55806 1.43306C9.80214 1.18898 10.1979 1.18898 10.4419 1.43306L12.9419 3.93306C13.186 4.17714 13.186 4.57286 12.9419 4.81694C12.6979 5.06102 12.3021 5.06102 12.0581 4.81694L9.55806 2.31694C9.31398 2.07286 9.31398 1.67714 9.55806 1.43306Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1831 6.69194L7.68306 4.19194L8.56694 3.30806L11.0669 5.80806L10.1831 6.69194Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.98244e317dae2f4556813084803b974b.svg";
export { ForwardRef as ReactComponent };